<style>

h3{
  text-align: center;
}

.space{
  margin: 20px;
}

</style>

<Auth bind:this="{auth}"></Auth>
<Profile bind:this="{profile}" bind:me="{me}"></Profile>

{#if show}

<h3>Change password</h3>
<h3>coming soon</h3>
<!-- 
<div class="space">
  <div>Old Password</div>
  <ValidPasswordInput bind:value="{oldPassword}" valid="{oldValid}" theme="light" on:changed="{checkOld}"></ValidPasswordInput>
</div>

<div class="space">
  <div>New Password</div>
  <ValidPasswordInput bind:value="{password}" valid="{valid}" theme="light" on:changed="{check}"></ValidPasswordInput>
</div>
<div class="small">10 or more characters required</div>
-->

{/if}


<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

import Auth from "../../interfaces/Auth.svelte";
let auth;

import Profile from "../../interfaces/Profile.svelte";
let profile;

import Validate from "../../helpers/Validate.js";
import Normalize from "../../helpers/Normalize.js";

import ValidPasswordInput from "../../components/ValidPasswordInput.svelte";

export let show = false;
export let me = null;

let tempPassword = "";
let oldPassword = "";
let password = "";
let valid = false;
let oldValid = false;
let signupDelayHandle = null;
let lastPassword = "";


function checkOld() {
  try {
    Validate.password(oldPassword);
    oldValid = true;
  } catch (e) {
    oldValid = false;
    console.log("error:", e);
  }
}


function check(e) {
  if (password == lastPassword) return;
  
  lastPassword = password;
  try {
    Validate.password(password);
    valid = true;
  } catch (e) {
    valid = false;
    console.log("error:", e);
  }
  
}


export const save = async () => {
  // save the component to saveMe
    
  console.log("SAVING password");
  // if (xxx != me.xxx) {
  //   me.xxx = xxx;
  //   profile.updateMe( { updateShare: true } );
  // }
}


</script>